<template>
  <div>
    <div class="error-dialog-with-user-interaction">
      <div class="ibf-h1 login-title">
        <span>{{ dialogData.status === statusType.connectivity ? $t('login.licenseError.title') : $t('login.licenseLocked.title') }}</span>
      </div>
      <div class="login-subtitle ibf-amount2 ib-color-text-grey">
        {{ dialogData.status === statusType.connectivity ? $t('login.licenseError.subtitle') : $t('login.licenseLocked.subtitle') }}
      </div>
      <div
        v-if="dialogData.status === statusType.unexpected"
        class="login-subtitle login-subtitle2 ibf-amount2 ib-color-text-grey"
      >
        {{ $t('login.licenseLocked.subtitle2') }}
      </div>
      <div class="icon-container">
        <img
          src="@/assets/images/error-red.png"
          class="error-icon"
          alt="Login Failed"
        />
        <div class="border l"></div>
        <div class="border m"></div>
        <div class="border r"></div>
        <div class="clear-fix"></div>
      </div>

      <span>
        <span class="retry-button-container">
          <div v-if="licensePending">propagate-loader</div>
          <q-btn
            v-else
            flat
            type="button"
            rounded
            no-caps
            tabindex="2"
            class="incredi-button-ibx primary-strong danger"
            :label="$t('login.licenseError.submitLabel')"
            @click.prevent.stop="refreshLicense(license?.key)"
          >
          </q-btn>
        </span>
      </span>

      <div
        id="login-support-link"
        :class="licenseRetryCount > 0 ? 'ib-color-almost_black' : 'ib-color-text-grey'"
      >
        <a
          tabindex="4"
          class="ibf-button2"
          :class="licenseRetryCount > 0 ? 'ib-color-almost_black' : 'ib-color-text-grey'"
          :href="supportMailUrl"
          >{{ $t('login.licenseForm.supportLinkDialog') }}</a
        >
      </div>
    </div>
    <div class="bottom-gradient danger">
      <div class="bottom-gradient1"></div>
      <div class="bottom-gradient2"></div>
    </div>
  </div>
</template>

<script>
import LicenseScript from '@/views/login/loginComponents/licenseFormMixins.vue';
import { mapGetters } from 'vuex';
import { useCommonDataQuery } from '@/graphql/codegen/generated/graphql';
import { defineComponent, inject } from 'vue';
import { IKCoordinatorsService } from '@/modules/CoordinatorsService/CoordinatorService.InjectionKeys';
import { refreshLicenseErrorStatus } from '../../../const/licensePage';

export default defineComponent({
  name: 'ConnectivityIssueDialog',
  mixins: [LicenseScript],
  setup() {
    const coordinatorsService = inject(IKCoordinatorsService);
    const GQL_useLicenseInfoQuery = useCommonDataQuery(() => ({ coordinatorId: coordinatorsService?.selectedCoordinator.value || '' }));
    return { GQL_useLicenseInfoQuery };
  },
  computed: {
    ...mapGetters({
      dialogData: ['main/dialogData'],
    }),
    statusType() {
      return refreshLicenseErrorStatus;
    },
    license() {
      return this.GQL_useLicenseInfoQuery?.result?.value?.ibManagerEntities?.license;
    },
  },
});
</script>

<style lang="scss" scoped>
.error-dialog-with-user-interaction {
  .login-subtitle {
    padding: 0 !important;
    margin-bottom: initial;
  }
  .login-subtitle2 {
    margin-bottom: 10px;
  }
  .icon-container {
    margin: 20px auto !important;
  }
}
</style>
